export default "__VITE_ASSET__C46Q37Z8__"